<template>
  <div class="pts-holder">
    <div id="ptsCanvas" @click="$emit('toggleDarkmode')"></div>
  </div>
</template>

<script>
import { CanvasSpace, Pt, Const, Line, Group } from "pts";

export default {
  name: "CircleAnimation",
  props: {
    darkmode: Boolean
  },
  data() {
    return {
      circleCenterX: 0,
      circleCenterY: 0,
      screenWidth: window.innerWidth
    };
  },
  mounted() {
    this.initPts();
  },

  methods: {
    initPts() {
      var that = this;
      var space = new CanvasSpace("#ptsCanvas").setup({
        bgcolor: "#000",
        resize: true,
        retina: true
      });
      var form = space.getForm();
      var pairs = [];

      // space.clear('rgba(255, 255, 255, 1)');
      space.autoResize = true;

      space.add({
        start() {
          that.circleCenterX = space.center[0] + that.screenWidth / 2;
          that.circleCenterY = space.center[1];

          let r = space.size.minValue().value / 1.5;

          for (let i = 0; i < 200; i++) {
            let ln = new Group(Pt.make(2, r, true), Pt.make(2, -r, true));
            ln.moveBy(that.circleLocation).rotate2D(
              (i * Math.PI) / 200,
              that.circleLocation
            );
            pairs.push(ln);
          }
        },

        animate: () => {
          for (let i = 0, len = pairs.length; i < len; i++) {
            // rotate each line by 0.1 degree and check collinearity with pointer
            let ln = pairs[i];
            ln.rotate2D(Const.one_degree / 50, that.circleLocation);
            let collinear = Line.collinear(ln[0], ln[1], space.pointer, 0.1);
            if (collinear) {
              if (this.darkmode) {
                form.stroke("#fff").line(ln);
              } else {
                form.stroke("#000").line(ln);
              }
            } else {
              // if not collinear, color the line based on whether the pointer is on left or right side
              let side = Line.sideOfPt2D(ln, space.pointer);
              form
                .stroke(
                  side < 0 ? "rgba(255,26,164,.2)" : "rgba(255,170,36,.2)"
                )
                .line(ln);
            }

            if (this.darkmode) {
              // form.fillOnly("#fff").point(space.pointer, 2, "circle");
              form.fillOnly("rgba(255,255,255,0.8)").points(ln, 0.5);
            } else {
              // form.fillOnly("#000").point(space.pointer, 2, "circle");
              form.fillOnly("rgba(0,0,0,0.8)").points(ln, 0.5);
            }
          }
        }
      });

      space
        .bindMouse()
        .bindTouch()
        .play();

      this.circleObject = space;
    }
  },

  computed: {
    circleLocation() {
      return [this.circleCenterX, this.circleCenterY];
    }
  },

  watch: {
    darkmode(val) {
      var that = this;
      if (val) {
        that.circleObject.clear("#000");
      } else {
        that.circleObject.clear("#fff");
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
div.pts-holder {
  position: absolute;
  top: 0;
  display: block;
  height: 100vh;
  width: 100%;
  overflow: hidden;
  z-index: 0;

  #ptsCanvas {
    width: 100%;
    height: 100%;
  }
}
</style>
